import { useAppState } from '../AppStateProvider';
import UrlService from '../services/UrlService';

export const useIsWithinTools = () => {
  const { url } = useAppState();
  const isWithinCalendar = !!url && UrlService.isCalendarUrl(new URL(url));
  const isWithinGmail = !!url && UrlService.isGmailUrl(new URL(url));
  const isWithinGoogleSheets = !!url && UrlService.isGoogleSheetsUrl(new URL(url));

  return { isWithinCalendar, isWithinGmail, isWithinTools: isWithinGmail || isWithinCalendar || isWithinGoogleSheets };
};
